<template>
  <div class="calls-section">
    <q-card flat bordered>
      <q-tabs
        v-model="callsTab"
        dense
        class="text-grey"
        active-color="primary"
        indicator-color="primary"
        align="justify"
        narrow-indicator
      >
        <q-tab
          style="text-transform: capitalize;"
          name="active"
          :label="activeLabel"
        ></q-tab>
        <q-tab
          style="text-transform: capitalize;"
          name="future"
          :label="futureLabel"
        ></q-tab>
        <q-tab
          style="text-transform: capitalize;"
          name="past"
          :label="pastLabel"
        ></q-tab>
      </q-tabs>

      <q-separator />

      <q-tab-panels v-model="callsTab" animated>
        <q-tab-panel name="active">
          <p
            v-if="!activeOpenings || activeOpenings.length == 0"
            class="text-left"
          >
            Er zijn geen openstaande openstellingen of huidige deadlines.
          </p>
          <div v-if="activeOpenings && activeOpenings.length > 0">
            <div v-for="item in activeOpenings" :key="item.id">
              <div class="row">
                <span
                  class="title text-left"
                  v-if="item.itemType == 2"
                  v-html="item.name"
                ></span>
                <router-link
                  v-else
                  style="text-decoration: none"
                  :to="{ name: 'GrantDetails', params: { grantId: item.id } }"
                  v-bind:target="openDetailsInNewTab ? '_blank' : null"
                >
                  <span class="title text-left" v-html="item.name"></span>
                </router-link>
                <q-space />
                <q-badge
                  outline
                  color="primary"
                  label="Gerelateerde openstelling"
                ></q-badge>
              </div>
              <div class="date-item text-left">
                <span class="date-label">Datum start: &nbsp;</span>
                <span class="date-value">{{ formatDate(item.callStart) }}</span>
              </div>
              <div class="date-item">
                <span class="date-label">Deadline: &nbsp;</span>
                <span class="date-value">{{ formatDate(item.callEnd) }}</span>
              </div>
              <div class="body" v-html="item.body"></div>
              <q-separator />
            </div>
          </div>
        </q-tab-panel>

        <q-tab-panel name="future">
          <p
            v-if="!futureOpenings || futureOpenings.length == 0"
            class="text-left"
          >
            Er zijn geen toekomst openstellingen.
          </p>
          <div v-if="futureOpenings && futureOpenings.length > 0">
            <div v-for="futureItem in futureOpenings" :key="futureItem.id">
              <div class="row">
                <router-link
                  style="text-decoration: none"
                  :to="{
                    name: 'GrantDetails',
                    params: { grantId: futureItem.id },
                  }"
                  v-bind:target="openDetailsInNewTab ? '_blank' : null"
                >
                  <span class="title text-left" v-html="futureItem.name"></span>
                </router-link>
                <q-space />
                <q-badge
                  outline
                  color="primary"
                  label="Gerelateerde openstelling"
                ></q-badge>
              </div>
              <div class="date-item text-left">
                <span class="date-label">Datum start: &nbsp;</span>
                <span class="date-value">{{
                  formatDate(futureItem.callStart)
                }}</span>
              </div>
              <div class="date-item">
                <span class="date-label">Deadline: &nbsp;</span>
                <span class="date-value">{{
                  formatDate(futureItem.callEnd)
                }}</span>
              </div>
              <div class="body" v-html="futureItem.body"></div>
              <q-separator />
            </div>
          </div>
        </q-tab-panel>

        <q-tab-panel name="past">
          <p v-if="!pastOpenings || pastOpenings.length == 0" class="text-left">
            Er zijn geen verleden openstellingen.
          </p>
          <div v-if="pastOpenings && pastOpenings.length > 0">
            <div v-for="pastItem in pastOpenings" :key="pastItem.id">
              <div class="row">
                <router-link
                  style="text-decoration: none"
                  :to="{
                    name: 'GrantDetails',
                    params: { grantId: pastItem.id },
                  }"
                  v-bind:target="openDetailsInNewTab ? '_blank' : null"
                >
                  <span class="title text-left" v-html="pastItem.name"></span>
                </router-link>
                <q-space />
                <q-badge
                  outline
                  color="primary"
                  label="Gerelateerde openstelling"
                ></q-badge>
              </div>
              <div class="date-item text-left">
                <span class="date-label">Datum start: &nbsp;</span>
                <span class="date-value">{{
                  formatDate(pastItem.callStart)
                }}</span>
              </div>

              <div class="date-item">
                <span class="date-label">Deadline: &nbsp;</span>
                <span class="date-value">{{
                  formatDate(pastItem.callEnd)
                }}</span>
              </div>
              <div class="body" v-html="pastItem.body"></div>
              <q-separator />
            </div>
          </div>
        </q-tab-panel>
      </q-tab-panels>
    </q-card>
  </div>
</template>

<script>
import { ref, computed } from 'vue';
import store from '../store/index';
import moment from 'moment';

export default {
  name: 'Calls',

  setup() {
    const callsTab = ref('active');

    const activeOpenings = computed({
      get: () => store.state.grantItems.activeOpenings,
    });

    const futureOpenings = computed({
      get: () => store.state.grantItems.futureOpenings,
    });

    const pastOpenings = computed({
      get: () => store.state.grantItems.pastOpenings,
    });

    const activeLabel = computed({
      get: () => store.state.grantItems.activeLength,
    });
    const futureLabel = computed({
      get: () => store.state.grantItems.futureLength,
    });
    const pastLabel = computed({
      get: () => store.state.grantItems.pastLength,
    });

    const formatDate = (stringDate) => {
      const date = new Date(stringDate);
      if (date.getFullYear() < 1000) return 'Onbepaald';
      else if (stringDate == null) return '-';
      return moment(date).format('DD-MM-YYYY');
    };

    const openDetailsInNewTab = computed({
      get: () => store.state.user.openDetailsInNewTab,
    });

    return {
      activeLabel,
      futureLabel,
      pastLabel,
      openDetailsInNewTab,
      callsTab,
      activeOpenings,
      futureOpenings,
      pastOpenings,
      formatDate,
    };
  },
};
</script>
